import applyTracking from '@becurious/applytracking';

export default class BookingEngine {
	/**
	 * Constructor
	 *
	 * @param {Object} config Configuration options
	 */
	constructor ({ hotelID }) {
		this.baseUrl = 'https://scripts.hoteliers.com/api/v1/book-form';
		this.language = 'en';
		this.config = {
			hotelID
		};
	}

	/**
	 * Convert a string representation of a date to a date object
	 *
	 * @param {*} date Date as an object or string
	 * @returns {String} Date as a string
	 */
	dateToString (date) {
		if (typeof date === 'string') {
			return date;
		}

		return date.getFullYear()
			+ '-'
			+ ('0' + (date.getMonth() + 1)).slice(-2)
			+ '-'
			+ ('0' + date.getDate()).slice(-2);
	}

	/**
	 * Open the booking engine
	 *
	 * For configuration options see:
	 * https://hoteliers.atlassian.net/wiki/spaces/DOCS/pages/996704480/Extra+options
	 *
	 * @param {object} options  Options object
	 *
	 * @return {void}
	 */
	getUrl (options) {
		if (!options.language) {
			options.language = this.language;
		}

		const url = new URL(this.baseUrl);
		url.search = (new URL(document.location)).searchParams;

		url.searchParams.append('hotel', this.config.hotelID);
		url.searchParams.append('lang', options.language);

		if (options.chain) {
			url.searchParams.append('chain', options.chain);
		}

		if (options.arrival) {
			url.searchParams.append('arrival', this.dateToString(options.arrival));
		}

		if (options.departure) {
			url.searchParams.append('departure', this.dateToString(options.departure));
		}

		if (options.promotioncode) {
			url.searchParams.append('promotion_code', options.promotioncode);
		}

		if (options.nights) {
			url.searchParams.append('nights', options.nights);
		}

		if (options.roomid) {
			url.searchParams.append('room_id', options.roomid);
		}

		if (options.packageid) {
			url.searchParams.append('package_id', options.packageid);
		}

		return applyTracking(url.href);
	}
}
